<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading"
      >
        <template slot="school_class" slot-scope="school_class">
          <div>{{ school_class.name }}</div>
        </template>
        <template slot="section" slot-scope="section">
          <div>{{ section.name }}</div>
        </template>
        <template slot="exam" slot-scope="exam">
          <div>
            <div class="font-weight-bold">{{exam.name}}</div>
          </div>
        </template>
        <template slot="is_all_section" slot-scope="is_all_section">
          <div>
            <a-tag color="green" v-if="is_all_section === 1">Yes</a-tag>
            <a-tag color="red" v-else>No</a-tag>
          </div>
        </template>
        <template slot="start_date" slot-scope="start_date">
          <div class="font-weight-bold">{{moment(start_date).format('DD-MM-YYYY')}}</div>
        </template>
        <template slot="end_date" slot-scope="end_date">
          <div class="font-weight-bold">{{moment(end_date).format('DD-MM-YYYY')}}</div>
        </template>
        <template slot="declared" slot-scope="declared">
          <div>
            <a-tag color="green" v-if="declared === 1">Declared</a-tag>
            <a-tag color="red" v-else>Not Declared</a-tag>
          </div>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <!-- Manage -->
            <a href="javascript:;" :class="['btn btn-sm btn-success btn-with-addon mr-2']"
              @click="handleAdmitcardClick(record)"
            >
              <span class="btn-addon">
                <i :class="['btn-addon-icon fe fe-square']" />
              </span>
              A/C
            </a>
            <!-- Manage -->
            <a href="javascript:;" :class="['btn btn-sm btn-primary mr-2']"
              @click="handleManageClick(record)"
            >
              <span class="btn-addon">
                <i :class="['btn-addon-icon fe', `${record.declared ? 'fe-eye' : 'fe-settings'}`]" />
              </span>
              <!-- {{ record.declared ? 'View' : 'Manage' }} -->
            </a>
            <!-- Edit -->
            <a href="javascript:;" :class="[`${record.declared ? 'disabled' : ''}`, 'btn btn-sm btn-light mr-2']"
              @click="showEditModal(record)"
              :disabled="record.declared ? true : false"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-edit" />
              </span>
            </a>
            <!-- Delete -->
            <a href="javascript:;" :class="[`${record.declared ? 'disabled' : ''}`, 'btn btn-sm btn-danger']"
              @click="onDelete(record)"
              :disabled="record.declared ? true : false"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-trash" />
              </span>
            </a>
          </div>
        </template>
      </a-table>
    </div>
    <!-- Edit Form -->
    <edit-exam-setup ref="editClassExamSetup" @edited="handleEdited"/>
  </div>
</template>
<script>
import moment from 'moment'

import EditExamSetup from '@/components/bosemexam/setup/Forms/Edit/index'

const columns = [
  {
    title: 'Class',
    dataIndex: 'school_class',
    scopedSlots: { customRender: 'school_class' },
    sorter: (a, b) => a.school_class.name.localeCompare(b.school_class.name),
  },
  {
    title: 'Section',
    dataIndex: 'section',
    scopedSlots: { customRender: 'section' },
    sorter: (d, e) => d.section.name.localeCompare(e.section.name),
  },
  {
    title: 'School Exams',
    dataIndex: 'exam',
    className: 'text-left text-gray-6',
    scopedSlots: { customRender: 'exam' },
    sorter: (d, e) => d.exam.name.localeCompare(e.exam.name),
  },
  {
    title: 'Same for all sections',
    dataIndex: 'is_all_section',
    scopedSlots: { customRender: 'is_all_section' },
  },
  {
    title: 'Start Date',
    dataIndex: 'start_date',
    scopedSlots: { customRender: 'start_date' },
    sorter: (a, b) => moment(a.start_date).unix() - moment(b.start_date).unix(),
  },
  {
    title: 'End Date',
    dataIndex: 'end_date',
    scopedSlots: { customRender: 'end_date' },
    sorter: (a, b) => moment(a.end_date).unix() - moment(b.end_date).unix(),
  },
  {
    title: 'Declared',
    dataIndex: 'declared',
    scopedSlots: { customRender: 'declared' },
    sorter: (a, b) => a.declared - b.declared,
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    className: 'text-right',
    scopedSlots: { customRender: 'action' },
  },
]

export default {

  name: 'ExamSetupTable',
  components: {
    EditExamSetup,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {
      columns,
      selectedRowKeys: [],
    }
  },
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    moment,
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    showEditModal: function(record) {
      // this.$refs.editClassExamSetup.showModal(record.id)
      this.$eventBus.$emit('openExamSetupEditModal', record.id)
    },
    handleManageClick: function (record) {
      this.$router.push({ name: 'bosemexammanage', params: { id: record.id } })
    },
    handleAdmitcardClick: function (record) {
      this.$router.push({ name: 'bosemexamadmitcard', params: { id: record.id } })
    },
    handleEdited: function () {
      this.$emit('updateTable')
    },
    onDelete: function(record) {
      this.$confirm({
        title: 'Are you sure?',
        content: 'Click Yes to delete this school exam!',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/classsectionexam/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: 'Successfully deleted class section exam setup.',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
